export const determineCalculationMethod = (
  building: Object,
): {
  requiredFractionPercentage: ?number,
  useFloorSpace: boolean,
} => {
  const { applicableFractionUnit, applicableFractionFloorSpace } = building;

  // Coerce DECIMAL fields (often returned as strings by Sequelize) to numbers
  const unitFraction =
    applicableFractionUnit == null ? null : Number(applicableFractionUnit);
  const floorSpaceFraction =
    applicableFractionFloorSpace == null
      ? null
      : Number(applicableFractionFloorSpace);

  // No fractions configured
  if (unitFraction == null && floorSpaceFraction == null) {
    return { requiredFractionPercentage: null, useFloorSpace: false };
  }

  // Only one configured
  if (floorSpaceFraction == null) {
    return { requiredFractionPercentage: unitFraction, useFloorSpace: false };
  }
  if (unitFraction == null) {
    return {
      requiredFractionPercentage: floorSpaceFraction,
      useFloorSpace: true,
    };
  }

  // Both configured - use the smaller
  return unitFraction <= floorSpaceFraction
    ? { requiredFractionPercentage: unitFraction, useFloorSpace: false }
    : { requiredFractionPercentage: floorSpaceFraction, useFloorSpace: true };
};
